import { makeVar, useReactiveVar } from '@apollo/client';
import { useCallback } from 'react';

/**
 * Keeps track of global state of users authentication status.
 */
export const authExpired = makeVar<boolean>(false);

export function useAuthExpired(): {
  authExpired: boolean;
  setAuthExpired: (expired: boolean) => void;
} {
  const value = useReactiveVar(authExpired);
  const setAuthExpired = useCallback((expired: boolean) => {
    authExpired(expired);
  }, []);
  return { authExpired: value, setAuthExpired };
}

/**
 * For local testing only.
 * Run `window.authExpired(true)` in the browser console to simulate expiring auth (does not expire your bearer).
 */
// if (typeof window !== 'undefined') {
//   window.authExpired = authExpired;
// }
